import api from "../../config/http-common";

const buildQuery = (filter) => {
    let query = '?pageNumber=' + filter.page + '&pageSize=' + filter.rowsPerPage;

    return query;
}

const createUrgentMessage = (payload) => {
    return api.securedAxios().post('/web/urgentMessage/create', payload);
}

const listUrgentMessages = (filter) => {
    return api.securedAxios().get('/web/urgentMessage/list' + buildQuery(filter));
}

export const UrgentMessagesService = {
    createUrgentMessage,
    listUrgentMessages
}